import _ from 'lodash'
import TextFilterMeta from './text-filter-meta'
import MultiChoiceFilterMeta from './multichoice'
import IdFilterMeta from './id-filter-meta'
import NumericFilter from '../../common/filter/numeric-filter'
import ColorFilter from './color-filter'
import TrendFilter from './trend-filter'
import PrincipalFilter from 'scoreboard/reports/common/filter/principal-filter'
import TagFilter from './tag-filter'
import MetricValueFilter from './metric-value-filter'
import AncestorFilter from 'scoreboard/reports/common/filter/ancestor-filter'
import CommonFilterMeta from 'scoreboard/reports/common/filter/common-filter-meta'
import OrgFilter from './org-filter'
import { CompareScorecardItemsFilterPath } from '../metric-comparison/metric-comparison-path'
import PrettyCompareScorecardItemsFilter from './pretty-compare-scorecard-items-filter'
import CompareScorecardFilterWizardLauncher from './compare-scorecard-filter-wizard-launcher'
import NumericAppliesToPeriodFilter from './numeric-applies-to-period-filter'
import suggestionUrl from 'scoreboard/reports/common/filter/suggestion-url'
import dateFilterMeta from 'scoreboard/reports/common/filter/date-filter-meta'
import booleanFilterMeta from 'scoreboard/reports/common/filter/boolean-filter-meta'

function numericFilterMeta(nameCode, columnType) {
	return {
		nameCode,
		filterType: 'numeric',
		form: NumericFilter,
		seed: suggestionUrl(columnType, 'scorecard-item')
	}
}

var FilterMeta = _.extend({
	weight: numericFilterMeta('report.customReport.weight', 'weight'),
	trend:{
		nameCode: 'report.customReport.trend',
		filterType: 'trend',
		form: TrendFilter,
		groupCode: 'common.performance'
	},
	owners: {
		nameCode: 'report.customReport.owners',
		assigneesInfo : {
			heading: 'common.owners',
			placeholder: 'admin.ownersUpdaters.addOwner'
		},
		filterType: 'id',
		form: PrincipalFilter,
		assigneeType: 'owners'
	},
	updaters: {
		nameCode: 'report.customReport.updaters',
		assigneesInfo : {
			heading: 'common.updaters',
			placeholder: 'admin.ownersUpdaters.addUpdater'
		},
		filterType: 'id',
		form: PrincipalFilter,
		assigneeType: 'updaters'
	},
	tagIds: {
		nameCode: 'report.customReport.tags',
		filterType: 'id',
		form: TagFilter,
		seed: 'api/tags'
	},
	score:{
		nameCode: 'report.customReport.score',
		filterType: 'range-numeric',
		form: NumericAppliesToPeriodFilter,
		groupCode: 'common.performance',
		seed: suggestionUrl('score', 'scorecard-item')
	},
	value:{
		nameCode: 'report.customReport.metricValue',
		filterType: 'range-numeric',
		form: MetricValueFilter,
		groupCode: 'common.performance',
		seed: suggestionUrl('actual', 'scorecard-item')
	},
	colors:{
		nameCode: 'report.customReport.scorecardColor',
		filterType: 'range-multichoice',
		form: ColorFilter,
		groupCode: 'common.performance',
		seed: suggestionUrl('color', 'scorecard-item')
	},
	scorecardNodeIds: {
		nameCode: 'report.customReport.scorecardNodeIds',
		filterType: 'ancestor',
		form: AncestorFilter,
		formOptions: {
			autoSelectRoot: true,
			showFollowLinked: true
		},
		dialogType: 'dark',
		//allowInlineDisplay false designates the view should be rendered in it's own dialog and not be combined with others
		//the default assumption is that views are inlinable
		allowInlineDisplay: false
	},
	organizationIds: {
		nameCode: 'report.customReport.specificOrganizations',
		filterType: 'org',
		form: OrgFilter,
		dialogType: 'dark',
		allowInlineDisplay: false,
		section: 'scorecards'
	},
	compareScorecardItems: {
		nameCode: 'report.designer.compareScorecardItems',
		filterType: 'compare-scorecards',
		filterKey: 'compareScorecardItems',
		dialogType: 'dark',
		path: CompareScorecardItemsFilterPath,
		stringify: PrettyCompareScorecardItemsFilter,
		//when editing, use wizard
		wizard: CompareScorecardFilterWizardLauncher
	},
	trend:{
		nameCode: 'report.customReport.trend',
		filterType: 'trend',
		form: TrendFilter,
		groupCode: 'common.performance'
	},
	start: dateFilterMeta('admin.scorecards.startsOn'),
	archive: dateFilterMeta('admin.scorecards.archivesOn'),
	precision: numericFilterMeta('scorecards.node.metric.decimalPrecision', 'precision'),
	higherBetter: booleanFilterMeta('scorecards.node.metric.higherValuesBetter'),
	yesGood: booleanFilterMeta('scorecards.node.metric.isYesGood')


}, TextFilterMeta, MultiChoiceFilterMeta, IdFilterMeta, CommonFilterMeta)

// default everything to the basic group
_.each(FilterMeta, meta => {
	if (!meta.groupCode) {
		meta.groupCode = 'admin.scorecards.metric.scoringType.basic'
	}
})

export default FilterMeta

FilterMeta.__filename__ = 'reports/wizard/filter-meta/scorecard-filter-meta.js'
